/** Segregação de funções (SoD): quem elaborou a conciliação não pode aprová-la (nem devolvê-la). O backend valida; a tela explica. */
export const MENSAGEM_AUTOR_NAO_APROVA =
  'Você é o responsável pela elaboração desta conciliação e, pela segregação de funções (SoD), não pode aprová-la. ' +
  'Encaminhe para outro aprovador com a alçada correspondente.';

export const souAutorDaConciliacao = (autorId?: number | null, meuUserId?: number | null): boolean =>
  autorId != null && meuUserId != null && autorId === meuUserId;
